import { render, staticRenderFns } from "./complaint.vue?vue&type=template&id=411d1958&"
import script from "./complaint.vue?vue&type=script&lang=js&"
export * from "./complaint.vue?vue&type=script&lang=js&"
import style0 from "./complaint.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports